type Props = {
  children?: React.ReactNode;
};

export default function SidebarPage(props: Props): JSX.Element {
  return (
    <div style={{ 
        flexBasis: 0,
        flexGrow: 999,
        textAlign: "center",
        overflowX: "auto",
        position: "relative",
        padding: "0 20px"
      }}>
      {props.children}
    </div>
  );
}